export default "__VITE_ASSET__g7bVe6U8__"